export default [
    {
      path: '/early-claim',
      component: () => import('./views/Index'),
      name: 'early-claim',
      redirect: { name: 'early-claim-list' },
      children: [
        {
          path: '',
          name: 'early-claim-list',
          component: () => import('./views/List'),
          meta: {
            resource: 'auth',
          },
        },
      ],
    },
  ]